<div class="mainFolder">
  <div class="folder f{{index}}" [ngClass]="{'active' : open && index === 0, 'linked': active}" (click)="gapiService.getFolderDetails(this, folder, index)">
    {{ folder.data.name }}
  </div>

  <div class="child" *ngFor="let item of childs">
    <app-folder *ngIf="open" [folder]="item" [index]="index + 1"></app-folder>
  </div>
</div>
